var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Configurator',{attrs:{"config":_vm.config,"shopConfig":_vm.shopConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }